// NOTE: adjust this import to your actual shared API helper path if different.
// Expected helpers: postBiz(service, action, payload), rows(response), json(response)

import { postBiz, rows, json } from '../core/coreapi';

const SERVICE = '';

export const normalizeBudgetVersion = (r: any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  rix: r.rix ?? r.recix,
  shc: r.shc ?? r.shortcode ?? r.versioncode ?? '',
  nam: r.nam ?? r.recname ?? r.versionname ?? '',
  dsc: r.dsc ?? r.description ?? '',
  fyr: r.fyr ?? r.fiscalyear ?? r.year ?? '',
  vty: r.vty ?? r.versiontype ?? '',
  aps: r.aps ?? r.approvalstage ?? '',
  sts: r.sts ?? r.status ?? '',
  ast: r.ast ?? r.status ?? 1,
  totalbudget: Number(r.totalbudget ?? r.tam ?? r.amount ?? 0),
  linecount: Number(r.linecount ?? r.lct ?? 0),
  raw: r,
});

export const normalizeBudgetVersionLine = (r: any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  versionid: r.versionid ?? r.bvi ?? null,
  sourcecode: r.sourcecode ?? r.src ?? '',
  costcentercode: r.costcentercode ?? r.ccc ?? '',
  costcentername: r.costcentername ?? r.ccn ?? '',
  accountcode: r.accountcode ?? r.acc ?? '',
  accountname: r.accountname ?? r.acn ?? '',
  lineitem: r.lineitem ?? r.nam ?? r.recname ?? '',
  description: r.description ?? r.dsc ?? '',
  amount: Number(r.amount ?? r.amt ?? r.totalbudget ?? 0),
  approvedamount: Number(r.approvedamount ?? r.apa ?? r.amount ?? r.amt ?? 0),
  raw: r,
});

export const normalizeVersionCards = (r: any) => ({
  versions: Number(r.versions ?? r.versioncount ?? 0),
  openversions: Number(r.openversions ?? 0),
  dgversions: Number(r.dgversions ?? 0),
  cavversions: Number(r.caversions ?? r.cavversions ?? 0),
  adoptedversions: Number(r.adoptedversions ?? 0),
  totalbudget: Number(r.totalbudget ?? r.amount ?? 0),
  linecount: Number(r.linecount ?? 0),
});

export const fetchBudgetVersions = async (filters: { fyr?: string | null; vty?: string | null; aps?: string | null }) =>
  rows(await postBiz({
    s: 'budgetversion', 
    a: 'find',
    fyr: filters.fyr || null,
    vty: filters.vty || null,
    aps: filters.aps || null,
    pgo: 0,
    pgl: 200,
  })).map(normalizeBudgetVersion);

export const fetchBudgetVersionCards = async () =>
  normalizeVersionCards(json(await postBiz({ s: 'budgetversion', a: 'cards',})));

export const fetchBudgetVersionLines = async (versionId: number, sourceCode = '', exceptionsOnly = false) =>
  rows(await postBiz({
    s: 'budgetversion', 
    a: 'lines',
    rid: versionId,
    src: sourceCode || null,
    exc: exceptionsOnly ? 1 : 0,
  })).map(normalizeBudgetVersionLine);

export const createBudgetRevision = async (payload: { fiscalYear: string; versionType: string; notes?: string }) =>
  json(await postBiz({
    s: 'budgetversion', 
    a: 'createrevision',
    fyr: payload.fiscalYear,
    vty: payload.versionType,
    nts: payload.notes || '',
  }));

export const freezeBudgetForDG = async (versionId: number, notes = '') =>
  json(await postBiz({ s: 'budgetversion', a: 'freeze_dg',rid: versionId, nts: notes }));

export const submitBudgetVersionToCA = async (versionId: number, policyCode: string, notes = '') =>
  json(await postBiz({ s: 'budgetversion', a: 'submit_ca',rid: versionId, gpc: policyCode, nts: notes }));

export const adoptBudgetVersion = async (versionId: number, notes = '') =>
  json(await postBiz({ 
    s: 'budgetversion', a: 'adopt',rid: versionId, nts: notes }));

export const defaultVersionTypes = [
  { shc: 'DRAFT', nam: 'Draft' },
  { shc: 'DG', nam: 'DG Review' },
  { shc: 'CA', nam: 'CA Review' },
  { shc: 'ADOPTED', nam: 'Adopted' },
];

export const defaultApprovalStages = [
  { shc: 'DRAFT', nam: 'Draft' },
  { shc: 'DG_REVIEW', nam: 'DG Review' },
  { shc: 'CA_REVIEW', nam: 'CA Review' },
  { shc: 'ADOPTED', nam: 'Adopted' },
];
